import { useSyncExternalStore } from "react"
import { PAGE_SIZE } from "../constants"

// la DataGrid MIT non supporta pagine oltre 100 righe
export const PAGE_SIZE_OPTIONS = [25, 50, 100]

const STORAGE_KEY = "tocc_page_size"
const listeners = new Set<() => void>()

function readPageSize() {
  try {
    const value = Number(window.localStorage.getItem(STORAGE_KEY))
    return PAGE_SIZE_OPTIONS.includes(value) ? value : PAGE_SIZE
  } catch {
    return PAGE_SIZE
  }
}

let currentPageSize = readPageSize()

export function setPageSize(pageSize: number) {
  currentPageSize = pageSize
  try {
    window.localStorage.setItem(STORAGE_KEY, String(pageSize))
  } catch {
    // storage not available, keep the value in memory only
  }
  listeners.forEach((listener) => listener())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

// unico setting condiviso da tutte le liste, persistito in localStorage
export function usePageSize() {
  return useSyncExternalStore(subscribe, () => currentPageSize)
}
